var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "calculate-editor" },
    [
      _c(
        "div",
        { staticClass: "editor-body" },
        [
          _c("formula-editor", {
            ref: "formulaEditor",
            attrs: {
              "available-variables": _vm.availableVariables,
              "all-function-names": _vm.allFunctionNames,
            },
            on: { input: _vm.handleFormulaInput },
            model: {
              value: _vm.formulaStr,
              callback: function ($$v) {
                _vm.formulaStr = $$v
              },
              expression: "formulaStr",
            },
          }),
          _c(
            "div",
            { staticClass: "content-section" },
            [
              _c("variable-panel", {
                attrs: {
                  categories: _vm.availableVariables.filter(
                    (item) => item.value !== "none"
                  ),
                },
                on: { select: _vm.handleVariableSelect },
              }),
              _c("function-panel", {
                attrs: {
                  categories: _vm.availableFunctionCategories,
                  "initial-expanded-categories": _vm.expandedCategories,
                },
                on: {
                  select: _vm.handleFunctionSelect,
                  hover: _vm.handleFunctionHover,
                },
              }),
              _c("function-detail", {
                attrs: { "selected-function": _vm.selectedFunction },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("editor-footer", {
        on: {
          cancel: function ($event) {
            return _vm.$emit("close")
          },
          confirm: _vm.confirmFormula,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }